<p>
  report-list works!
</p>



// WEBPACK FOOTER //
// /opt/app/src/app/features/report/report-list/report-list.component.html